import React from 'react';
import { Avatar, Box, SvgIcon, Typography, useTheme } from '@material-ui/core';
import { useSelector } from 'react-redux';
import QuillEditor from '../QuillEditor';
import {TaskWithDetailedTriggeredAction} from "../../types";
import IconRenderer from "../IconRenderer";
import {EVENT_ATTRIBUTES_BY_EVENT_TYPE} from "../../constants/constants";
import SlateRichTextArea from "../slate/SlateRichTextArea";

const TaskCell = ({ task }: { task: TaskWithDetailedTriggeredAction }) => {
    const theme = useTheme();
    const account = useSelector((state) => (state as any).account);
    let { description, icon } = task;

    // todo - task needs icon
    return (
      <Box display="flex" alignItems="center">
        <Box mr={1}>
          <Avatar style={{ backgroundColor: theme.palette.secondary.main }}>
            <SvgIcon fontSize="small">
              <IconRenderer iconName={icon} />
            </SvgIcon>
          </Avatar>
        </Box>
        <Box>
          <Typography variant="h6">
            {task.title}
          </Typography>
            {
                task.triggeredAction ? (
                  <Typography variant="body2" color="textSecondary">
                    This action requires your approval before executing.
                  </Typography>
                ) : (
                    description ? <SlateRichTextArea value={description} readOnly /> : (
                      <Box fontStyle="italic">
                        <Typography variant="body2" color="textSecondary">
                          No description.
                        </Typography>
                      </Box>
                    )
                )
            }
        </Box>
      </Box>
    );
};
export default TaskCell;
